import api from '../config/axiosConfig';

export const ticketService = {
    fetchTicket: async ({ token, pagina = 1, pageSize = 20, desde, hasta, estado, tipo, nombre }) => {
        try {
            const response = await api.get('/tickets/all', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, estado, tipo, nombre },
            });

            return {
                tickets: response.data.tickets || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en ticketService.fetchTicket:', error);
            throw error;
        }
    },
    getEstadoTicket: async (token) => {
        try {
            const response = await api.get('/tickets/estados',
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.estados;
        } catch (error) {
            console.error('Error en getEstadoTicket:', error);
            throw error;
        }
    },
    getTiposSolicitud: async (token) => {
        try {
            const response = await api.get('/tickets/tiposolicitud',
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.tipoSolicitud;
        } catch (error) {
            console.error('Error en getTiposSolicitud:', error);
            throw error;
        }
    },
    exportarSolicitudesExcel: async (token, filtros) => {
        try {
            const response = await api.post('/tickets/exportarAll', filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ticketService.exportarSolicitudesExcel:', error);
            throw error;
        }
    },
    guardarTipoSolicitud: async ({ token, formData, editingItem }) => {
        try {
            if (editingItem) {
                await api.put(`/tickets/tiposolicitud/${editingItem.id}`,
                    formData,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            } else {
                await api.post('/tickets/tiposolicitud', formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
        } catch (error) {
            console.error('Error en ticketService.guardarSolicitudes:', error);
            throw error;
        }
    },
    getTicketById: async (token, id) => {
        try {
            const response = await api.get(`/tickets/${id}/agent`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error en getTicketById:', error);
            throw error;
        }
    },
    getMessageByTicket: async (token, id) => {
        try {
            const response = await api.get(`/tickets/message/${id}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error en getMessageByTicket:', error);
            throw error;
        }
    },
    marcarMensajesComoLeidos: async (token, ticketId, sender_type = 'user') => {
        try {
            const response = await api.post(`/tickets/message/marcar-leidos/${ticketId}`,
                {
                    sender_type: sender_type,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Error en marcarMensajesComoLeidos:', error);
            throw error;
        }
    },
    atenderTicket: async (token, ticketId) => {
        try {
            await api.get(`/tickets/${ticketId}/atender`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
        } catch (error) {
            console.error('Error en ticketService.atenderTicket:', error);
            throw error;
        }
    },
    sendMessage: async (token, ticketId, payload, sender_type = 'agent') => {
        try {
            let data = {};
            let headers = { Authorization: `Bearer ${token}` };
            if (payload instanceof FormData) {
                data = payload;
            } else {
                data = {
                    message: payload,
                    sender_type: sender_type,
                };
            }

            await api.post(`/tickets/${ticketId}/messages`,
                data,
                {
                    headers: headers,
                }
            );
        } catch (error) {
            console.error('Error en ticketService.sendMessage:', error);
            throw error;
        }
    },
    cerrarTicket: async (token, ticketId) => {
        await api.get(`/tickets/${ticketId}/cerrar`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    },
    exportarTicket: async (token, ticketId) => {
        try {
            const response = await api.post(`/tickets/${ticketId}/exportar`, {}, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ticketService.exportarTicket:', error);
            throw error;
        }
    },
    getTicketMessageNoLeido: async ({ token }) => {
        try {
            const response = await api.get('/tickets/messagesnoleidos', {
                headers: { Authorization: `Bearer ${token}` },
            });

            return {
                tickets: response.data.tickets || [],
            };
        } catch (error) {
            console.error('Error en ticketService.getTicketMessageNoLeido:', error);
            throw error;
        }
    },
};
